<template>
  <div class="about">
    <div class="headImg">
      <!-- <img src="../../assets/about/headImg.png" alt="" /> -->
      <img :src="`http://www.china-tillage.com:8000${headImg}`" alt=""  style="width:100%;"/>
    </div>
    <div class="aboutUsList">
      <div class="subject">
        <!-- 主体部分 -->
        <div>
          <!-- <p class="title">关于我们</p>
          <p class="subTitle">about us</p> -->
          <div class="text" v-html="aboutData">
            <!-- <p>
              四川泰立智汇科技有限公司创建于2005年，自成立以来，公司始终以“创新、专业、敢为、重德”的核心理念为指导思想，以为“客户、
              股东、员工、社会”创造价值为经营理念，引进并推广机电行业、建筑智能化行业、节能降耗行业的前沿技术和设备，为客户提供集设计、
              施工、咨询及运维为一体的建筑机电系统综合解决方案和服务
            </p>
            <p>公司现已具备机电安装壹级、消防设施工程壹级、电子智能化工程壹级、钢结构工程贰级等专项资质，通过了质量管理体系、环境管理
               体系、职业健康安全管理体系认证，并成为国际地源热泵协会、中国建筑节能协会、四川省制冷学会和四川省建设科技协会等行业专业机构成员。
            </p>
            <p>经过十余年的市场磨砺与发展,公司已拥有建筑机电的系统集成和智慧管理两大核心业务，已累计为医院、学校、企业、银行、金融中心、
              科技园区、研究所、商业综合体、高端地产配套、机场航站、精密工厂楼等多领域跨行业的逾五百家客户提供了机电系统集成服务和智能
              管理服务，并与多家央企、上市公司建立了长期战略合作关系。
            </p>
            <p>泰立紧紧把握建筑机电管理创新需求，发挥自身优势，将产业和资本相结合，应用物联网、云计算、大数据等先进技术，实施跨越式发展战
              略，以机电系统集成和机电智慧管理为发展主体，将经验与创新相结合，科技与文化相融合，打造以智能化为主的建筑机电系统集成商和运营
              商，为客户、社会、公众提供科技节能的建筑机电综合解决方案和增值服务，成为中国机电智慧服务的主要提供商。
            </p> -->
          </div>
        </div>
        <!-- 分组介绍 -->
        <!-- <div class="groups">
          <p class="title">建筑机电系统集成的引领者</p>
          <p class="subTitle">
            集机电系统地设计、施工及运维于一体的综合性机电系统集成商。具备四川省建设厅颁发的机电设备安装工程、建筑智能化工程及消防设施工程
            的一级资质，钢结构工程二级资质。泰立在机电系统集成业务领域，拥有一支创新、高效、专业的高素质管理团队，丰富的经验与先进的管理制
            度的结合，使得泰立多年来在该领域取得了骄人的成绩和市场认可。
          </p>
        </div>
        <div class="groups">
          <p class="title">建筑机电系统集成的引领者</p>
          <p class="subTitle">
            集机电系统地设计、施工及运维于一体的综合性机电系统集成商。具备四川省建设厅颁发的机电设备安装工程、建筑智能化工程及消防设施工程
            的一级资质，钢结构工程二级资质。泰立在机电系统集成业务领域，拥有一支创新、高效、专业的高素质管理团队，丰富的经验与先进的管理制
            度的结合，使得泰立多年来在该领域取得了骄人的成绩和市场认可。
          </p>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { baseURL } from "../../../config.ts"

export default {
  name: "about",
  data() {
    return {
      aboutData: "",
      headImg: "",
      baseURL: null,
    }
  },
  components: {},
  mounted() {
    this.baseURL = baseURL
    this.getheadImg()
    this.getNewsLsit()
  },
  methods: {
    // 获取新闻大图
    getheadImg(){
      this.$http.get(`${baseURL}/json/img/about`).then( (res)=>{
          // console.log(res,"头部图片")
          this.headImg = res.data.pic
        }
      ).catch((err)=>{
        console.log(err)
      })
    },
    // 获取新闻列表
    getNewsLsit(){
      this.$http.get(`${baseURL}/json/about`).then( (res)=>{
          // console.log(res,"about")
          // this.aboutData = res.data
          this.aboutData = res.data.content.replace(/src="/g,`src="${baseURL}`)
        }
      ).catch((err)=>{
        console.log(err)
      })
    },
  },
};
</script>

<style lang="scss" scope>
* {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
.about {
  .headImg {
    width: 100%;
    // height: 656px;
    overflow: hidden;
  }
  .aboutUsList {
    // width: 60%;
    width: 1200px;
    padding: 50px 0%;
    // border: 1px solid red;
    margin: 0 auto;
    .subject {
      padding: 20px 0;
      p.title {
        font-size: 40px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        text-align: center;
        color: #040f36;
        line-height: 40px;
        text-shadow: 0px 2px 5px 0px rgba(6, 30, 58, 0.28);
        padding: 10px 0;
      }
      p.subTitle {
        font-size: 34px;
        font-family: PingFangSC, PingFangSC-Light;
        font-weight: 300;
        text-align: center;
        color: #040f36;
        line-height: 34px;
        text-shadow: 0px 2px 5px 0px rgba(6, 30, 58, 0.28);
      }
      div.text{
        padding: 20px 0;
         p{
          font-size: 16px;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          text-align: justify;
          color: #040f36;
          line-height: 26px;
          padding: 10px 0;
          text-indent: 2rem;
        }
      }
      .groups{
        padding: 10px 0;
        .title{
          font-size: 16px;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 900;
          text-align: center;
          color: #040f36;
          line-height: 26px;
        }
        .subTitle{
          font-size: 16px;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 500;
          text-align: left;
          text-indent: 2rem;
          color: #040f36;
          line-height: 26px;
        }
      }
    }
  }
}
</style>
